/* eslint-disable */
/*
 * Websocket Loader
*/

import Event from '../events';
import EventHandler from '../event-handler';
import SlicesReader from '../utils/h264-nal-slicesreader.js';

import utils from '../../../utils'
import NotifyMsg from '../../../notify/src/NotifyMsg'
import BinaryWriter from '../../../notify/src/BinaryWriter'
import BinaryReader from '../../../notify/src/BinaryReader'
import MediaCenterMsg from '../../src/MediaCenterMsg';

const ATYP = {
  IP4: 1,
  DOMAIN: 3,
  IP6: 4
};

//eslint-disable-next-line
const YUV_HEAD_SIZE = 48; // YUV 数据头长度
const STA = 0x44415441;

class WebsocketLoader extends EventHandler {

  constructor(wfs) {
    super(wfs, 
    Event.WEBSOCKET_ATTACHING,
    Event.WEBSOCKET_DATA_UPLOADING,
    Event.WEBSOCKET_MESSAGE_SENDING)   
    this.buf = null;
    this.slicesReader = new SlicesReader(wfs);
    this.mediaType = undefined; 
    this.channelName = undefined;
    this.recvBuffer = new utils.Buffer(8 * 1024); // 接收缓存
  }
 
  destroy() { 
	  !!this.client && this.client.close();
	  this.slicesReader.destroy();
    EventHandler.prototype.destroy.call(this);
    this.recvBuffer = null;
  }

  onWebsocketAttaching(data) {
  	this.mediaType = data.mediaType; 
  	this.channelName = data.channelName;  
    if( data.websocket instanceof WebSocket ) {
      this.client = data.websocket;
      this.client.onopen = this.initSocketClient.bind(this);   
      this.client.onclose = function(e) {
          console.debug('Websocket Disconnected!');
      }; 
    }    
  }

  initSocketClient(client){
    this.client.binaryType = 'arraybuffer';
    this.client.onmessage = this.onHankshakeRecv.bind(this);
    this.wfs.trigger(Event.WEBSOCKET_MESSAGE_SENDING, {
      commandType: "open",
      channelName:this.channelName,
      commandValue:"NA"
    });
    console.debug('Websocket Open!'); 
  }
 
  receiveSocketMessage( event ){
    try {
      const that = this;
      const msgs = [];
      const data = new Uint8Array(event.data);
      MediaCenterMsg.writeBuffer(this.recvBuffer, {
          buffer: data,
          offset: 0,
          count: data.length
      }, function(msg) {
        //console.log(msg);
        if (msg.isPong()) {
          // do nothing
          console.debug('Recv Pong');
        }
        else if (msg.isPing()) {
          console.debug('Recv Ping');
          that.sendPong();
        }
        else if (msg.isCameraInfo()) {
          const jsonStr = utils.utf8ByteArrayToString(msg.msgData || []);
          var info = JSON.parse(jsonStr);
          that.cameraInfo = info;
          console.debug('Camera Info', info);
          that.wfs.trigger(Event.CAMERA_INFO_RECEIVED, {
            cameraInfo: info
          });
        }
        else if (msg.isYUVData()) {
          msgs.push(msg);
        }
        else if (msg.isError()) {
          if (msg.msgCode != 0) {
            var errmsg = utils.utf8ByteArrayToString(msg.msgData) || '预览失败';
            console.error(errmsg);
            this.client.close();
          }
        }
        else {
          // drop data
          console.debug('Unknown msg', msg);
        }
      });
      if (msgs.length > 0) {
          for (let i = 0;i < msgs.length; i++) {
            this.handleYUVMsg(msgs[i]);
          }
      }
    }
    catch(ex) {
      console.error(ex);
      this.client.close();
    }   
  }

  handleYUVMsg(msg) {
    try {
      const yuv = this.parseYUVData(msg.msgData);

      //console.log(yuv);

      this.buf = new Uint8Array(yuv.data);
      var copy = new Uint8Array(this.buf);   
      
      if (this.mediaType ==='FMp4'){
        this.wfs.trigger(Event.WEBSOCKET_ATTACHED, {payload: copy });
      }

      if (this.mediaType === 'H264Raw'){
        this.wfs.trigger(Event.H264_DATA_PARSING, {data: copy });
      }
    }
    catch(e) {
      console.error(e);
      this.client.close();
    }
  }
  
  // 解码数据
  parseYUVData(data) {
    let yuv = {};
    const reader = new ZJNotify.BinaryReader(data, 0, data.length);
    yuv.sta = reader.readInt32();        // 4 字节起始位，固定为 0x44415441
    yuv.dataSize = reader.readInt32();   // 4 字节数据长度
    yuv.rawDataSize = reader.readInt32();// 4 字节原始长度
    yuv.yStride = reader.readInt32();    // 4 字节 yStride
    yuv.uvStride = reader.readInt32();   // 4 字节 uvStride
    yuv.timestamp = reader.readInt32();  // 4 字节时间戳
    yuv.frameType = reader.readInt32();  // 4 字节帧类型
    yuv.width = reader.readInt32();      // 4 字节宽度
    yuv.height = reader.readInt32();     // 4 字节高度
    yuv.sendTime = reader.readUInt64();  // 8 字节发送时间
    yuv.zipMethod = reader.readInt8();   // 1 字节压缩方式
    yuv.reserve0 = reader.readInt8();    // 1 字节保留位
    yuv.reserve1 = reader.readInt16();   // 2 字节保留位

    if (yuv.sta != STA) {
        throw new Error('Invalid STA');
    }

    const yuvData = data.subarray(YUV_HEAD_SIZE, YUV_HEAD_SIZE + yuv.dataSize)
    yuv.data = yuvData;

    //console.debug(yuv.timestamp +
    //    ' ' + yuv.width + 'x' + yuv.height +
    //    ' ' + utils.humanReadableSize(yuv.dataSize) +
    //    ' 耗时 ' + (new Date().getTime() - yuv.sendTime) + ' 毫秒');

    return yuv;
  }

  onWebsocketDataUploading( event ){
    this.client.send( event.data );
  }
  
  onWebsocketMessageSending( event ){
    const msg = this.buildHandshakeMsg();
    this.client.send(msg);
    console.debug('Websocket Connecting ' + addr.host + ':' + addr.port + ' (' + addr.mode + ')'); 
  }

  onHankshakeRecv(event) {
    try {
      const msg = this.parseHankshakeMsg(event.data);
      this.client.binaryType = 'arraybuffer';
      this.client.onmessage = this.receiveSocketMessage.bind(this);
      console.debug('Websocket Connected! ' + msg.proxyIP + ':' + msg.proxyPort);
      this.sendPlayCmd();
    }
    catch(e) {
      console.error(e);
      this.client.close();
    }
  }
  
  sendPong() {
    const data = MediaCenterMsg.build(MediaCenterMsg.RESPONSE, MediaCenterMsg.PONG);
    this.client.send(Uint8Array.from(data));
    console.debug('Send Pong');
  }

  sendPlayCmd() {
    const data = MediaCenterMsg.build(
      MediaCenterMsg.REQUEST,
      MediaCenterMsg.PREVIEW,
      this.channelName || {});
    this.client.send(Uint8Array.from(data));
    console.debug('Websocket Send Play Command');
  }

  parseHankshakeMsg(data) {
    const msg = NotifyMsg.parseFromArrayBuffer(data);
    const blk = (msg.blocks||[])[0] || [];
    const reader = new BinaryReader(blk.data||[]);
    let ver = reader.readInt8();
    let code = reader.readInt8();
    let rsv = reader.readInt8();
    let atyp = reader.readInt8();
    if ( ver != 0x5  || code != 0   || rsv != 0x01 ||
         (atyp != ATYP.IP4 && atyp != ATYP.IP6 && atyp != ATYP.DOMAIN) ) {
      throw new Error('Invalid handshake response');
    }
    const ip = 
        atyp == ATYP.IP4 ? WebsocketLoader.readIPv4(reader) :
        atyp == ATYP.IP6 ? WebsocketLoader.readIPv6(reader) :
        atyp == ATYP.DOMAIN ? WebsocketLoader.readDomain(reader) : '';
    const port = reader.readInt16();
    return {
      proxyIP: ip,
      proxyPort: port
    };
  }

  buildHandshakeMsg() {
    let addr = this.getMediaCenterAddress();
    let data = [];
    const writer = new BinaryWriter(data);
    // 参考 SOCKS5 协议
    writer.writeInt8(0x05); // SOCKS 协议版本
    writer.writeInt8(0x01); // CONNECT 命令
    writer.writeInt8(0x01); // RSV 保留字段
    writer.writeInt8(ATYP.DOMAIN); // 地址类型
    const domain = utils.stringToUtf8ByteArray(addr.host || "");
    writer.writeInt8(domain.length);
    writer.writeArrayBuffer(domain, 0, domain.length);
    writer.writeInt16(addr.port || 0);
    const wsmsg = NotifyMsg.wrap('CONNECT', data, this.getToken());
    wsmsg.header.cmd = addr.mode == 'tcp' ? NotifyMsg.CMD_TCP_PIPE : NotifyMsg.CMD_UDP_PIPE;
    wsmsg.header.cmdParam = 0;
    return wsmsg.getArrayBuffer();
  }

  getMediaCenterAddress() {
    const mediaCenterAddress = this.wfs.getAppConfig('mediaCenter.address');
    const mode = this.wfs.getAppConfig('mediaCenter.mode') || 'tcp';
    const index = mediaCenterAddress.lastIndexOf(':');
    const mediaCenterIp = mediaCenterAddress.substr(0, index);
    const mediaCenterPort = parseInt(mediaCenterAddress.substr(index + 1));
    return {
      host: mediaCenterIp,
      port: mediaCenterPort,
      mode: mode
    }
  }

  getToken() {
    const global = window || {};
    const $notify = global.$notify;
    return $notify.getToken();
  }

  getProxyUrl() {
    const global = window || {};
    const $notify = global.$notify;
    return $notify.getProxyUrl();
  }

  static readIPv4(reader) {
    let ip = '';
    ip += reader.readInt8();
    ip += '.';
    ip += reader.readInt8();
    ip += '.';
    ip += reader.readInt8();
    ip += '.';
    ip += reader.readInt8();
    return ip;
  }

  static readIPv6(reader) {
    let ip = [];
    for (let i = 0; i < 8; i++) {
        let s = reader.readInt16().toString(16);
        for (let j = s.length; j < 4; j++) {
            s = '0' + s;
        }
        ip.push(s);
    }
  
    // 压缩 IPv6
    let z = [{
        cmp: ip[0],
        count: 1
    }];
    for (let i = 1; i < 8; i++) {
        if (ip[i] === '0000' && z[z.length - 1].cmp === '0000') {
            z[z.length - 1].count++;
        }
        else {
            z.push({
                cmp: ip[i],
                count: 1
            });
        }
    }

    let max = 0, index = -1;
    for (let i = 0; i < z.length; i++) {
        if (z[i].cmp === '0000') {
            if (z[i].count >= max) {
                max = z[i].count;
                index = i;
            }
        }
    }

    if (index != -1) {
        ip = [];
        for (let i = 0; i < z.length; i++) {
            if (i == index) {
                ip.push('');
            }
            else {
                for (let j = 0; j < z[i].count; j++) {
                    ip.push(z[i].cmp);
                }
            }
        }
    }

    return '[' + ip.join(':') + ']';
  }

  static readDomain(reader) {
    let len = reader.readInt8();
    let arr = [];
    reader.readBuffer(arr, 0, len);
    let ip = utils.utf8ByteArrayToString(arr);
    return ip;
  }
}

export default WebsocketLoader;  